import { DiaperOutlineIcon } from './DiaperOutlineIcon';

/**
 * author: Jeff Anders
 * id 060C6C30-A2B7-430F-A90B-03483819BBD0
 * name diaper-outline
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/diaper-outline.svg
 * tags
 * - Clothing 
 * - Medical / Hospital 
 */
export const NappyOutlineIcon = DiaperOutlineIcon;
export default NappyOutlineIcon